export default __webpack_public_path__ + "static/media/click-url.c98dfb03.svg";